<div class="tw-p-4 tw-rounded-md tw-shadow-lg tw-w-full tw-max-w-md tw-flex tw-flex-col tw-h-[70vh] tw-overflow-hidden">

  <h2 class="tw-text-100 tw-uppercase tw-font-body tw-font-bold tw-text-gray-800 tw-border-b tw-pb-2 tw-text-lg sm:tw-text-xl" i18n="@@selectProducts">
    Select products
    </h2>

  <div class="tw-overflow-y-auto tw-overflow-x-hidden tw-flex-1 tw-mb-[-40px] tw-px-2 tw-pt-2">
    @for (product of data?.content; track product; let isLast = $last; let isFirst = $first) {
      <div
        class="tw-border-b tw-py-3 tw-w-full"
        [ngClass]="{ 'tw-border-b': !isLast, 'tw-pt-4': isFirst }">
        <label class="tw-flex tw-items-start tw-gap-3 tw-w-full tw-cursor-pointer">
          <input
            type="checkbox"
            class="tw-sr-only"
            [checked]="isProductSelected(product.objectId)"
            (change)="onProductChecked(product.objectId, $event)"/>
          <span
            class="tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-rounded-[3px] tw-border tw-border-gray-400 tw-mt-1"
            [ngClass]="{'tw-bg-teal-600 tw-border-teal-600': isProductSelected(product.objectId)}">
            @if (isProductSelected(product.objectId)) {
              <span
                class="tw-block tw-w-[8px] tw-h-[4px] tw-border-b-[2px] tw-border-l-[2px] tw-border-white tw-rotate-[-45deg]">
              </span>
            }
          </span>
          <img
            [src]="product.rebrandedImageWithBackground"
            alt="Product Img"
            class="tw-w-[42px] tw-h-12 tw-rounded-md tw-border"/>
          <div class="tw-flex tw-flex-col tw-flex-1">
            <span class="tw-text-200 tw-font-bold tw-font-body" [ngClass]="{ 'selected': isProductSelected(product.objectId) }">
              {{ product.title }}
            </span>
            <span class="tw-text-100 tw-text-gray-300 tw-font-body">
              {{ product?.quantity }} {{ product?.quantityUnit }}
            </span>
          </div>
        </label>
      </div>
    }
  </div>

  <div class="tw-flex tw-w-full tw-items-center tw-justify-between tw-pt-[42px] tw-pb-4 tw-sticky tw-bottom-0 tw-z-10 tw-bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,#ffffff_36.5%,#ffffff_79.84%)]">
    <button
      class="tw-text-teal-600 tw-font-body tw-w-1/2 tw-justify-center tw-items-center tw-font-bold tw-text-sm sm:tw-text-base"
      (click)="closedPopup()"
    i18n="@@cancel">Cancel</button>

    <button
        [ngClass]="{
          'tw-bg-[#CECECE] tw-rounded-[12px] tw-pointer-events-none':
            !selectedProducts.length,
          'tw-bg-teal-600 tw-text-300 tw-rounded-[12px]':
            selectedProducts.length
        }"
      class="tw-w-1/2 tw-font-body tw-justify-center tw-text-white tw-text-300 tw-py-2 tw-rounded-xl tw-h-[40px] tw-flex tw-items-center tw-font-bold"
      (click)="openNativePopup()"
    i18n="@@continue">Continue</button>
  </div>
</div>
